<div id="ShowAllPills" class="modal is-touch is-short" [ngClass]="{ 'is-open': isPillModalOpenStatus }">
  @if (isPillModalOpenStatus) {
    <div class="modal__content">
      <div class="p2 flex justify-content-between align-center">
        <div class="pl1 flex align-center gray-15">
          <div class="flex flex-column">
            <div class="flex height100">
              <div id="icon-{{displayItem?.itemId}}" class="h3 flex flex-column pr1">
                <absg-icons [customId]="'patientDispenseIcons-'+displayItem?.itemId" [isAuditFavorite]="displayItem?.isItemAuditFavorite()"
                  [iconProvider]="displayItem" [suppressBinIcon]="displayItem?.itemSuppressBinIcon()"></absg-icons>
              </div>
              <div>
                <div id="pillItemName" class="h3 mb1 bold gray-15">{{displayItem?.name}}</div>
                @if (displayItem?.patientOwnedId) {
                  <div id="patientOwnedInfo{{displayItem?.itemId}}" class="drug-name--alternate truncate--single">
                    <div>
                      @if (displayItem?.patientOwnedItemTypeShortName) {
                        <span class="h6 bold gray-15">
                          {{displayItem?.patientOwnedItemTypeShortName}}</span>
                      }
                      {{displayItem?.patientOwnedDemographics}}
                    </div>
                  </div>
                }
                <div class="flex">
                  <div id="lblpillItemNdc" class="h5 gray-40">NDC</div>
                  <div id="pillItemNdc" class="h4 ml1 bold gray-15">{{displayItem?.ndc}}</div>
                  <div id="lblpillItemId" class="h5 ml3 gray-40">Item #</div>
                  <div id="pillItemId" class="h4 ml1 bold gray-15">{{displayItem?.itemId}}</div>
                </div>
                <div id="statuspill-{{displayItem?.itemId}}" class="mt2">
                  <absg-status-pills [customId]="displayItem?.itemId" [statusProvider]="displayItem" [isWitness]="displayItem?.isWitness"
                    [maxPillCountOnPage]="0"></absg-status-pills>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <button id="pillCloseModal" class="btn btn--true-blue" (click)="closeModal()">OK</button>
        </div>
      </div>
    </div>
  }
</div>